import * as React from 'react';
import InteractivePage from './interactivePage';
import DroppablePage from './droppablePage';
import BasePage from './basePage';
import type { AdaptedPage, Page as PageType } from '../flowTypes';
import PageFooter from './pageFooter';
import { stringTruncateWithEllipsis } from '../../../utility';

type PropType = {
  page: PageType,
  zoom: number,
  floatingFieldType: ?string,
  updateFloatingFieldType: Function,
  setCurrentPageOnMouseMove: Function,
  activeSelectionPageFields: Array<number>,
  handleActiveSelectionMove: Function,
  handleClipboardFieldClear: Function,
  handleClipboardFieldAdd: Function,
  handleClipboardFieldsPaste: Function,
  handleSelectedFieldsDuplicate: Function,
  activeSelectionPageFieldPos: { [string]: { x: number, y: number } },
  deleteActiveSelectionFields: Function,
  copyFieldsToClipboard: Function,
  passPageRefToEditor: Function,
  pages: Array<AdaptedPage>,
  pageIndex: number,
  mode: string,
  handleActiveSelectionClear: Function,
  pdfPages: Object,
  addFieldsToSelection: (fieldIds: Array<number>, ?{ resetSelection: boolean }) => void,
  handleUpdateZoom: Function,
  handlePreviewField: Function,
  handleFieldAdd: (type: string, top: number, left: number, pageIndex: number) => void,
};

const DOC_NAME_LENGTH = 75;

const Page = ({
  pages,
  zoom,
  floatingFieldType,
  updateFloatingFieldType,
  setCurrentPageOnMouseMove,
  activeSelectionPageFields,
  handleClipboardFieldClear,
  handleClipboardFieldAdd,
  handleClipboardFieldsPaste,
  handleSelectedFieldsDuplicate,
  activeSelectionPageFieldPos,
  deleteActiveSelectionFields,
  copyFieldsToClipboard,
  handleActiveSelectionMove,
  passPageRefToEditor,
  pageIndex,
  mode,
  handleActiveSelectionClear,
  addFieldsToSelection,
  handleUpdateZoom,
  pdfPages,
  handlePreviewField,
  handleFieldAdd,
  ...restProps
}: PropType) => {

  if (pages[pageIndex]) {
    return (
      <React.Fragment>
        <InteractivePage
          pageIndex={pageIndex}
          page={pages[pageIndex]}
          floatingFieldType={floatingFieldType}
          updateFloatingFieldType={updateFloatingFieldType}
          setCurrentPageOnMouseMove={setCurrentPageOnMouseMove}
          activeSelectionPageFields={activeSelectionPageFields}
          handleClipboardFieldClear={handleClipboardFieldClear}
          handleClipboardFieldsPaste={handleClipboardFieldsPaste}
          handleSelectedFieldsDuplicate={handleSelectedFieldsDuplicate}
          activeSelectionPageFieldPos={activeSelectionPageFieldPos}
          deleteActiveSelectionFields={deleteActiveSelectionFields}
          copyFieldsToClipboard={copyFieldsToClipboard}
          handleActiveSelectionMove={handleActiveSelectionMove}
          passPageRefToEditor={passPageRefToEditor}
          outsideClickIgnoreClass="pageOutClick"
          mode={mode}
          handleActiveSelectionClear={handleActiveSelectionClear}
          zoom={zoom}
          addFieldsToSelection={addFieldsToSelection}
          handleUpdateZoom={handleUpdateZoom}
          handlePreviewField={handlePreviewField}
          handleFieldAdd={handleFieldAdd}
        >
          <BasePage
            page={pages[pageIndex]}
            totalPages={pages.length}
            zoom={zoom}
            pdfPages={pdfPages}
          >
            <DroppablePage
              zoom={zoom}
              pages={pages}
              activeSelectionPageFields={activeSelectionPageFields}
              handleActiveSelectionMove={handleActiveSelectionMove}
              handleSelectedFieldsDuplicate={handleSelectedFieldsDuplicate}
              pageIndex={pageIndex}
              mode={mode}
              handleActiveSelectionClear={handleActiveSelectionClear}
              addFieldsToSelection={addFieldsToSelection}
              handleFieldAdd={handleFieldAdd}
              {...restProps}
            />
          </BasePage>
        </InteractivePage>
        <PageFooter
          formName={stringTruncateWithEllipsis(pages[pageIndex].documentName, DOC_NAME_LENGTH)}
          totalPages={pdfPages && pdfPages[pages[pageIndex].documentId] && pdfPages[pages[pageIndex].documentId].documentLength}
          pageNumber={pages[pageIndex].pageNumber}
          height={pages[pageIndex].height}
          width={pages[pageIndex].width}
          zoom={zoom}
          pageIndex={pageIndex}
        />
      </React.Fragment>
    );
  }

  return null;
};

export default Page;
